import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { PriceTableContextName } from '@api-ui-app/src/app/shared/pricing-table/constants/price-table-context-name';
import { DialogRef } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-ref';
import { DIALOG_DATA } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-tokens';
import { DialogSize } from '@gelato-api-ui/sdk/src/lib/shared/dialog/types/dialog-size';

interface EstimatedTaxesDisclaimerModalContext {
  contextName: PriceTableContextName;
}

@Component({
  selector: 'gd-estimated-taxes-disclaimer-modal',
  templateUrl: './estimated-taxes-disclaimer-modal.component.html',
  styleUrls: ['./estimated-taxes-disclaimer-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstimatedTaxesDisclaimerModalComponent {
  size = DialogSize.Small;
  consentGiven: boolean;

  constructor(
    private readonly dialogRef: DialogRef,
    @Inject(DIALOG_DATA) private readonly dialogData: EstimatedTaxesDisclaimerModalContext,
  ) {}

  get contextName() {
    return this.dialogData.contextName;
  }

  close() {
    this.dialogRef.close(false);
  }

  continue() {
    this.dialogRef.close(true);
  }
}
